module.exports = __webpack_public_path__ + "img/discover2.10217993.jpg";